import React, { useState, useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";
import Subitens from "../../../../components/Subitens";
import { Container, Box, Header, FormBlock } from "./styles";
import { isAuthAdmin } from "../../../../services/auth";

import swal from "sweetalert";
import {
  Form,
  Input,
  FormField,
  FormGroup,
  Button,
  Select,
} from "semantic-ui-react";
import { useRouter } from "../../../../hooks/router";

const RelatorioPersonalizacao = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());

  const [loadingNovo, setLoadingNovo] = useState(false);
  const [loadingAntigo, setLoadingAntigo] = useState(false);

  const [relatorioNovo, setRelatorioNovo] = useState(false);
  const [relatorioAntigo, setRelatorioAntigo] = useState(false);

  const [item, setItem] = useState();
  const [load, setLoad] = useState(false);

  const router = useRouter();

  const initialLoad = useCallback(() => {
    const { item } = router.query;

    setItem(Number(item || "0"));
    setLoad(true);
  }, [router]);

  useEffect(() => {
    initialLoad();
  }, []);

  const handleGenerateReport = useCallback(
    (value) => {
      if (value == "new") {
        setRelatorioNovo(false);
        setLoadingNovo(true);
      } else {
        setRelatorioAntigo(false);
        setLoadingAntigo(true);
      }
      api
        .post(`admin/relatorio-subitens`, {
          data_inicio: dataInicio,
          data_final: dataFinal,
        })
        .then((res) => {
          if (value == "new") {
            setRelatorioNovo(...[res.data.response]);
            setLoadingNovo(false);
          } else {
            setRelatorioAntigo(...[res.data.response]);
            setLoadingAntigo(false);
          }

          let array = {
            local: "Relatorio/subitens",
            texto: `Gerou o relatorio entre ${dataInicio} e ${dataFinal}}`,
          };
          api.post("system_logs", { acao: JSON.stringify(array) });
          swal("Confirmado!", "Relatório gerado com sucesso", "success");
          window.open(res.data.response, "blank");
        })
        .catch((error) => {
          if (value == "new") {
            setLoadingNovo(false);
          } else {
            setLoadingAntigo(false);
          }

          if (error.response) {
            swal(
              `Algo deu errado`,
              `Se persistir, contate nosso suporte`,
              "error"
            );
          }
        });
    },
    [dataInicio, dataFinal, swal]
  );

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório Subitens</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="green"
                onClick={() => handleGenerateReport("new")}
                loading={loadingNovo}
              >
                Gerar Relatório
              </Button>
              {relatorioNovo && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorioNovo, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>

        {/* {load && <Subitens item={item} />} */}
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioPersonalizacao;
